import React from 'react';
import { GlobeIcon } from 'lucide-react';
const currencies = [{
  flag: '🇲🇽',
  label: 'MXN'
}, {
  flag: '🇨🇴',
  label: 'COP'
}, {
  flag: '🇦🇷',
  label: 'ARS'
}, {
  flag: '🇵🇪',
  label: 'PEN'
}, {
  flag: '🇨🇱',
  label: 'CLP'
}, {
  flag: '🇺🇸',
  label: 'USD'
}];
export function CurrencyNote() {
  return <section className="bg-concrete-950 pb-16 sm:pb-20" aria-labelledby="moneda" data-id="element-60" data-mp="1e3oyrjtka2qn">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-61" data-mp="104fqd6blkcx8">
        <div className="flex flex-col gap-5 border border-concrete-700 bg-concrete-900 p-6 sm:flex-row sm:items-center sm:gap-7 sm:p-8" data-id="element-62" data-mp="107227i5itel9">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-safety text-safety-ink" aria-hidden="true" data-id="element-63" data-mp="q7b31360mbeu">
            <GlobeIcon className="h-6 w-6" data-id="element-64" data-mp="2kksvn4la1ygq" />
          </span>
          <div className="flex-1" data-id="element-65" data-mp="2klc31rdax4gi">
            <h2 id="moneda" className="font-display text-xl uppercase leading-tight text-concrete-50 sm:text-2xl" data-id="element-66" data-mp="2kizjj9rwam1c">
              Quédate tranquilo: vas a pagar en la moneda de tu país
            </h2>
            <p className="mt-2 text-base leading-relaxed text-concrete-400" data-id="element-67" data-mp="356tsqbaxvwqm">
              El precio se muestra en dólares, pero al momento de pagar la
              plataforma lo convierte solito a tu moneda local. Sin cuentas raras
              ni sorpresas en tu tarjeta.
            </p>
            <ul className="mt-4 flex flex-wrap gap-2" data-id="element-68" data-mp="2r7c01kuivzbz">
              {currencies.map(c => <li key={c.label} className="flex items-center gap-1.5 border border-concrete-700 bg-concrete-950 px-2.5 py-1 text-xs font-bold uppercase tracking-wide text-concrete-200" data-id="element-69" data-mp="2m9slejtwxkji">
                  <span aria-hidden="true" data-id="element-70" data-mp="2v8e0g506ehfj">{c.flag}</span>
                  {c.label}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}